// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";


const firebaseConfig = {
  apiKey: "AIzaSyBvUytFYLmFhd50kB6BWTt0c-YjPBofKVE",
  authDomain: "webohmydog.firebaseapp.com",
  databaseURL: "https://webohmydog-default-rtdb.firebaseio.com",
  projectId: "webohmydog",
  storageBucket: "webohmydog.appspot.com",
  messagingSenderId: "801785707865",
  appId: "1:801785707865:web:b43daab0d93003c6012048",
  measurementId: "G-9QNE1L823J"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

//initialize firebase auth
const auth = getAuth();

// Initialize Realtime Database and get a reference to the service
const database = getDatabase(app);

export { app, auth, database };

